import { keyframes, css } from 'styled-components'
import { CssAnimationProps } from '@ocean/ui/dist/animations'

const slideInUpAndFadeIn = keyframes`
  from {
    transform: translate(0, 30px);
    opacity: 0;
  }

  to {
    transform: translate(0, 0);
    opacity: 1;
  }
`

const animation = css<CssAnimationProps>`
  animation: ${slideInUpAndFadeIn} ${({ animationDuration }) => animationDuration || '2s'}
    cubic-bezier(0.7, 0, 0.84, 0); /* easeOutCubic */
`

export default animation
